import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=5217320a&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=ts&"
export * from "./Paging.vue?vue&type=script&lang=ts&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=5217320a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217320a",
  null
  
)

export default component.exports